import {type SeverityType, useSetNotificationStack} from '../states/NotificationStack'

import {useEvent} from './useEvent'

interface Hook {
  readonly notifySuccess: (message: string) => void
  readonly notifyError: (message: string) => void
  readonly notifyInfo: (message: string) => void
}

export function useNotification(): Hook {
  const setNotificationStack = useSetNotificationStack()

  const notify = useEvent((message: string, severity: SeverityType): void => {
    const key = message
    setNotificationStack((previous) => ({
      ...previous,
      [key]: {
        key,
        severity,
        message,
      },
    }))
  })
  const notifySuccess = useEvent((message: string): void => {
    notify(message, 'success')
  })
  const notifyError = useEvent((message: string): void => {
    notify(message, 'error')
  })
  const notifyInfo = useEvent((message: string): void => {
    notify(message, 'info')
  })

  return {
    notifyInfo,
    notifyError,
    notifySuccess,
  }
}
